import { Pipe, PipeTransform } from '@angular/core';
import { sanitizeDocument } from '@shared/utils/cnpj-utils';

@Pipe({ name: 'cpfCnpjFormat' })
export class CpfCnpjFormatPipe implements PipeTransform {
  transform(value: string | number): string {
    if (!value) {
      return '';
    }

    const cleanValue = sanitizeDocument(value.toString());

    if (!cleanValue) {
      return '';
    }

    if (cleanValue.length === 11) {
      return this.formatCpf(cleanValue);
    } else if (cleanValue.length === 14) {
      return this.formatCnpj(cleanValue);
    } else {
      return cleanValue;
    }
  }

  private formatCpf(cpf: string): string {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  private formatCnpj(cnpj: string): string {
    const first = cnpj.slice(0, 2);
    const second = cnpj.slice(2, 5);
    const third = cnpj.slice(5, 8);
    const fourth = cnpj.slice(8, 12);
    const dv = cnpj.slice(12, 14);
    return `${first}.${second}.${third}/${fourth}-${dv}`;
  }
}
